import { useTranslation } from "react-i18next";

import type { SensorIcon } from "@map/logic";
import { cn } from "@utils";

type AreaBusynessLabelProps = {
  status: SensorIcon;
};

export const AreaBusynessLabel = ({ status }: AreaBusynessLabelProps) => {
  const { t } = useTranslation();

  if (status === "unknown") return null;

  const labels: Record<Exclude<SensorIcon, "unknown">, string> = {
    full: t("translation:Full"),
    busy: t("translation:Busy"),
    lively: t("translation:Lively"),
    quiet: t("translation:Quiet"),
  };

  return (
    <span className="flex flex-none items-center gap-2 rounded-md border border-mapiq-black-150 px-1.5 py-0.5">
      <span
        className={cn("size-2 rounded-full", {
          "bg-functional-red": status === "full",
          "bg-functional-orange": status === "busy",
          "bg-[#ddbe3b]": status === "lively",
          "bg-functional-green": status === "quiet",
        })}
      />

      <span className="text-[13px] font-semibold text-mapiq-black-500">{labels[status]}</span>
    </span>
  );
};
